import React from 'react';
import { useTranslate } from 'gatsby-theme-soluble-source';

export default function ButtonCookies() {
    const _ = useTranslate();

    return (
        <button
            type="button"
            id="hs_show_banner_button"
            style={{
                backgroundColor: '#2b2634',
                border: 'none',
                padding: '10px 16px',
                textDecoration: 'none',
                color: '#fff',
                fontFamily: 'inherit',
                fontSize: '14px',
                fontWeight: 'normal',
                lineHeight: '20px',
                textAlign: 'left',
                textShadow: 'none',
                position: 'fixed',
                bottom: '0',
                right: '0',
            }}
            onClick={() => {
                var _hsp = (window._hsp = window._hsp || []);
                _hsp.push(['showBanner']);
            }}>
            {_['cookies.button'].text}
        </button>
    );
}
